import { render } from "./editor_request_viewer.vue?vue&type=template&id=b8a4219e"
import script from "./editor_request_viewer.vue?vue&type=script&lang=js"
export * from "./editor_request_viewer.vue?vue&type=script&lang=js"

import "./editor_request_viewer.vue?vue&type=style&index=0&id=b8a4219e&lang=sass"

import exportComponent from "/builds/b.braun/pharmacist/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn,QInput,QPopupProxy,QDate,QDialog,QCard,QCardSection,QCardActions});qInstall(script, 'directives', {ClosePopup});
